/**
 * @generated SignedSource<<289f00afddf7773c03a189baea485850>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateEmailLayoutInput = {
  htmlContent?: string | null | undefined;
  isDefault?: boolean | null | undefined;
  name: string;
};
export type CreateEmailLayoutDialogMutation$variables = {
  input: CreateEmailLayoutInput;
};
export type CreateEmailLayoutDialogMutation$data = {
  readonly createEmailLayout: {
    readonly id: string;
    readonly name: string;
  };
};
export type CreateEmailLayoutDialogMutation = {
  response: CreateEmailLayoutDialogMutation$data;
  variables: CreateEmailLayoutDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailLayout",
    "kind": "LinkedField",
    "name": "createEmailLayout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEmailLayoutDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateEmailLayoutDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a477849936e408136263a10f33965425",
    "id": null,
    "metadata": {},
    "name": "CreateEmailLayoutDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateEmailLayoutDialogMutation(\n  $input: CreateEmailLayoutInput!\n) {\n  createEmailLayout(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4b7e41721449fb0e8a738bf8260ae76";

export default node;
